module.exports = __webpack_public_path__ + "img/twitter.548676c0.svg";